module.exports = __webpack_public_path__ + "img/hsbc-cover.500e2e40.jpg";